import React from 'react'
import { parseISO, format } from 'date-fns'

class DayPicker extends React.PureComponent {
  static defaultProps = {
    defaultValue: null,
    value: null,
    onChange: () => {},
    showChanges: false,
    style: {},
    className: '',
    disabled: false,
    title: '',
    minDate: null,
    maxDate: null,
    label: '',
  }

  constructor(props) {
    super(props)
    this.state = {
      value: props.defaultValue || props.value || null,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  formatDate = date => {
    if (!date) return ''
    date = typeof date === 'string' ? parseISO(date) : date
    return format(date, 'yyyy-MM-dd') // Formato YYYY-MM-DD
  }

  parseDate = dateString => {
    return dateString ? parseISO(dateString) : null
  }

  handleChange = e => {
    const { value } = e.target
    const parsedDate = this.parseDate(value)
    this.setState({ value: parsedDate })
    this.props.onChange({ ...this.props, value: parsedDate })
  }

  render() {
    const { label, disabled, className, style, title, minDate, maxDate } = this.props
    const { value } = this.state
    return (
      <div title={title} className={`day-picker ${disabled ? 'disabled' : ''} ${className}`} style={style}>
        {label && <div className="label">{label}</div>}
        <input
          type="date"
          value={this.formatDate(value)}
          onChange={this.handleChange}
          disabled={disabled}
          min={minDate ? format(minDate, 'yyyy-MM-dd') : ''}
          max={maxDate ? format(maxDate, 'yyyy-MM-dd') : ''}
          className="day-picker-input form-control"
        />
        <style jsx="true">{`
          .day-picker {
            display: flex;
            align-items: center;
          }
          .day-picker.disabled input {
            background: #f0f2f5;
            cursor: not-allowed;
          }
          .day-picker input {
            font-size: 1rem;
            padding: 0.25rem;
            width: 100%;
            max-width: 200px;
            text-align: center;
            border: 1px solid #ccc;
            border-radius: 4px;
          }
          .day-picker input:focus {
            border-color: var(--primary);
            outline: none;
          }
          .day-picker .label {
            background: var(--bs-primary);
            color: #fff;
            margin-right: 0 !important;
            margin-bottom: 0 !important;
            border-top-left-radius: 0.35rem !important;
            border-bottom-left-radius: 0.35rem !important;
          }
        `}</style>
      </div>
    )
  }
}

export default DayPicker
